import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { ScrollReveal } from './ScrollReveal';
import { Link } from 'react-router-dom';
import { useBooking } from '../contexts/BookingContext';
export function HeroSection() {
  const [scrollY, setScrollY] = useState(0);
  const {
    openBooking
  } = useBooking();
  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <section className="relative pt-32 pb-20 md:pt-40 md:pb-32 flex items-center min-h-[90vh] overflow-hidden" data-id="element-526">
      {/* Background Image with Parallax */}
      <div className="absolute inset-0 z-0 scale-110" style={{
      transform: `translateY(${scrollY * 0.4}px)`
    }} data-id="element-527">
        <img src="https://cdn.rawproductionsgmbh.de/2n/home/header.jpg" alt="Zahnärztliche Fortbildung" className="w-full h-full object-cover object-center" data-id="element-528" />
        <div className="absolute inset-0 bg-[#1a1a1a]/70 mix-blend-multiply" data-id="element-529"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a1a] via-[#1a1a1a]/40 to-transparent" data-id="element-530"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-531">
        <div className="max-w-3xl mx-auto text-center" data-id="element-532">
          <ScrollReveal variant="up" delay={100} data-id="element-533">
            <span className="inline-block py-1.5 px-4 rounded-full bg-[#59d0d4]/20 text-[#59d0d4] text-xs sm:text-sm font-extrabold tracking-wider sm:tracking-widest uppercase mb-6 border border-[#59d0d4]/30 backdrop-blur-sm" data-id="element-534">
              2N | Fortbildungsinstitut
            </span>
          </ScrollReveal>

          <ScrollReveal variant="up" delay={300} data-id="element-535">
            <h1 className="text-3xl md:text-6xl lg:text-7xl text-white leading-tight mb-6 tracking-tight font-[600]" data-id="element-536">
              Akademie für zahnärztliche Fortbildung
            </h1>
          </ScrollReveal>

          <ScrollReveal variant="up" delay={500} data-id="element-537">
            <p className="text-base sm:text-lg md:text-2xl text-slate-300 mb-10 font-medium leading-relaxed max-w-2xl mx-auto" data-id="element-538">
              Ihre Kurse & Curriculum in Bayern, Nürnberg. Praxisnahe,
              zertifizierte Weiterbildung für Zahnärzte, Oralchirurgen und
              Praxisteams.
            </p>
          </ScrollReveal>

          <ScrollReveal variant="up" delay={700} data-id="element-539">
            <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-3 sm:gap-4" data-id="element-540">
              <a href="#kurse" className="inline-flex items-center justify-center px-6 py-3 sm:px-8 sm:py-4 text-base sm:text-lg font-bold rounded-md text-white bg-[#3b7780] hover:bg-[#2d5f66] transition-all hover:scale-105 shadow-[0_0_20px_rgba(59,119,128,0.4)]" data-id="element-541">
                Kurse entdecken
                <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-542" />
              </a>
              <a href="#curriculum" className="inline-flex items-center justify-center px-6 py-3 sm:px-8 sm:py-4 text-base sm:text-lg font-bold rounded-md text-white bg-white/10 hover:bg-white/20 border border-white/30 backdrop-blur-sm transition-all hover:scale-105" data-id="element-543">
                Zum Curriculum
              </a>
              <button onClick={openBooking} className="inline-flex items-center justify-center px-6 py-3 sm:px-8 sm:py-4 text-base sm:text-lg font-bold rounded-md bg-[#59d0d4] hover:bg-[#4abfc3] transition-all hover:scale-105 shadow-lg text-slate-900" data-id="element-544">
                Jetzt Kursplan sichern
                <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-545" />
              </button>
            </div>
          </ScrollReveal>

          <ScrollReveal variant="up" delay={900} data-id="element-546">
            <div className="flex gap-4 sm:gap-8 md:gap-12 mt-10 pt-8 sm:mt-16 sm:pt-10 border-t border-white/10 flex-col md:flex-row items-center justify-center" data-id="element-547">
              <img src="https://cdn.rawproductionsgmbh.de/2n/logos/sitelogo.png" alt="2N Fortbildungen" className="h-10 sm:h-14 w-auto object-contain" data-id="element-548" />
              <img src="https://cdn.rawproductionsgmbh.de/2n/logos/APW-Logo.png" alt="APW" className="h-10 sm:h-14 w-auto object-contain" data-id="element-549" />
              <img src="https://cdn.rawproductionsgmbh.de/2n/logos/DGZMK.png" alt="DGZMK" className="h-10 sm:h-14 w-auto object-contain" data-id="element-550" />
              <img src="https://cdn.rawproductionsgmbh.de/2n/logos/DGSZM.png" alt="DGSZM" className="h-10 sm:h-14 w-auto object-contain" data-id="element-551" />
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>;
}